import { render, staticRenderFns } from "./UserInfoDisplay.vue?vue&type=template&id=9c84a944&scoped=true&"
import script from "./UserInfoDisplay.vue?vue&type=script&lang=js&"
export * from "./UserInfoDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c84a944",
  null
  
)

export default component.exports